import { emailRegex, phoneNumberRegex } from '../../../Shared/Frontend/utils/email-and-phone.regex'
import {
  CheckboxField,
  EmailField,
  FieldBaseWithValueAndRequired,
  FullNameField,
  PhoneNumberField,
  Question,
  RadioField,
} from './jotform.state'

export const stringValueRequiredErrorMessage = (field: FieldBaseWithValueAndRequired<string>) =>
  field.required && !field.value ? 'Dit veld is verplicht.' : undefined

export const emailInvalidErrorMessage = (field: EmailField) =>
  field.value && !new RegExp(emailRegex()).test(field.value) ? 'Voer een geldig emailadres in' : undefined

export const emailExtraConfirmationErrorMessage = (field: EmailField) =>
  field.extraConfirmationField
    ? field.required && !field.extraConfirmationField.value
      ? 'Dit veld is verplicht.'
      : field.extraConfirmationField.value != field.value
      ? 'Je email is niet gelijk'
      : undefined
    : undefined

export const phoneInvalidErrorMessage = (field: PhoneNumberField) =>
  field.value && !new RegExp(phoneNumberRegex()).test(field.value) ? 'Voer een geldig telefoonnummer in' : undefined

export const firstRequiredInvalid = (field: FullNameField) => field.required && !field.subFields.first.value
export const lastRequiredInvalid = (field: FullNameField) => field.required && !field.subFields.last.value
export const fullNameRequiredErrorMessage = (field: FullNameField) =>
  firstRequiredInvalid(field) || lastRequiredInvalid(field) ? 'Dit veld is verplicht.' : undefined

export const radioExtraOptionErrorMessage = (field: RadioField) =>
  field.extraOption && field.required && field.value == field.extraOption.label && !field.extraOption.value
    ? 'Dit veld is verplicht.'
    : undefined

export const checkBoxErrorMessage = (field: CheckboxField) =>
  field.required && field.value.length < 1 ? 'Dit veld is verplicht.' : undefined

export const checkboxExtraOptionErrorMessage = (field: CheckboxField) =>
  field.extraOption && field.required && field.value.includes(field.extraOption.label) && !field.extraOption.value
    ? 'Dit veld is verplicht.'
    : undefined

export const hasErrors = (field: Question) => {
  switch (field.kind) {
    case 'input':
    case 'textarea':
    case 'number':
    case 'select':
      return stringValueRequiredErrorMessage(field)
    case 'email':
      return (
        stringValueRequiredErrorMessage(field) ||
        emailInvalidErrorMessage(field) ||
        emailExtraConfirmationErrorMessage(field)
      )
    case 'phone':
      return stringValueRequiredErrorMessage(field) || phoneInvalidErrorMessage(field)
    case 'fullName':
      return fullNameRequiredErrorMessage(field)
    case 'radio':
      return stringValueRequiredErrorMessage(field) || radioExtraOptionErrorMessage(field)
    case 'checkbox':
      return checkBoxErrorMessage(field) || checkboxExtraOptionErrorMessage(field)
    case 'submitButton':
      return false
  }
}
